/**
 * dementia-report.js — платный разбор теста на деменцию (PDF).
 *
 * Карточку рисует ОБЩИЙ примитив <x-perk-gate perk="dementia_report"> (+ perk-gate.js):
 * план заголовком, разово 99 ₽ второй строкой, токены там, где план уже
 * израсходован. Этот файл делает то, что знает тул:
 *   • хранит результат В ЭТОМ БРАУЗЕРЕ (localStorage) — сервер его не хранит
 *     (данные о здоровье, шапка config/dementia-report.php) и получает только
 *     в запросе сборки;
 *   • park()  — завести ПРАВО на разбор при первом признаке намерения купить
 *     (без результата: только номер и ключ);
 *   • issue() — собрать PDF вошедшему (перк плана или токены решает сервер);
 *   • возврат из кассы `?dt_paid=<право>` и письмо `…&dt_key=` — собрать оплаченное;
 *   • оплаченное, но не полученное право — предложить скачать на любой загрузке.
 *
 * ES2018-safe, обычный скрипт (defer).
 */
(function () {
'use strict';

var PERK = 'dementia_report';
var KEY = 'dt_report_v1';
var MAX_ITEMS = 5;
var CUR = null;         // {rid, payload} текущего результата на экране
var PARKING = null;
var registered = false;

function conf() { return window.__DTR || { T: {}, cfg: {} }; }
function T(k) { var d = conf().T || {}; return typeof d[k] === 'string' ? d[k] : ''; }
function enabled() { return !!(conf().cfg && conf().cfg.enabled); }
function locale() { return window.__LOCALE || document.documentElement.lang || 'ru'; }
function ae(stage, extra) {
    try { window.__aeFunnel && window.__aeFunnel(stage, extra || {}); } catch (e) {}
}
function csrf() {
    var m = document.querySelector('meta[name="csrf-token"]');
    return m ? m.getAttribute('content') : '';
}
function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
}

/* ── хранилище браузера ──────────────────────────────────────────────── */

/* ⚠️ localStorage бывает недоступен (приватное окно, запрет сайта) — тогда
 * разбор всё равно собирается по результату на экране, просто повторно
 * скачать его после перезагрузки будет не из чего. */
function load() {
    try {
        var s = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (s && Array.isArray(s.items)) return s;
    } catch (e) {}
    return { items: [], paid: null };
}
function save(s) {
    try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
}
function findItem(s, pred) {
    for (var i = 0; i < s.items.length; i++) if (pred(s.items[i])) return s.items[i];
    return null;
}
function remember(rep) {
    var s = load();
    if (!findItem(s, function (it) { return it.rid === rep.rid; })) {
        s.items.unshift({ rid: rep.rid, payload: rep.payload, at: Date.now(), pass: null, got: false });
        s.items = s.items.slice(0, MAX_ITEMS);
        save(s);
    }
}
function setPass(rid, pass) {
    var s = load();
    var it = findItem(s, function (x) { return x.rid === rid; });
    if (it) { it.pass = pass; save(s); }
}
function markGot(rid) {
    var s = load();
    var it = findItem(s, function (x) { return x.rid === rid; });
    if (it) { it.got = true; save(s); }
}

/* ── сеть ────────────────────────────────────────────────────────────── */

/* ⚠️ Анонимному страница приходит из кэша с ЧУЖИМ токеном и без сессионной
 * куки — первый POST ловит 419. Ждём общий __csrfReady(). */
function post(url, body, wantPdf) {
    var ready = (typeof window.__csrfReady === 'function') ? window.__csrfReady() : Promise.resolve(null);
    return ready.then(function () {
        return fetch(url, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'Accept': wantPdf ? 'application/pdf, application/json' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-TOKEN': csrf()
            },
            body: JSON.stringify(body || {})
        });
    }).then(function (r) {
        var ct = (r.headers.get('Content-Type') || '').toLowerCase();
        if (wantPdf && r.ok && ct.indexOf('application/pdf') === 0) {
            return r.blob().then(function (b) { return { status: r.status, blob: b, name: fileName(r) }; });
        }
        return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, json: j || {} }; });
    }).catch(function () { return { status: 0, json: { error: 'network' } }; });
}

function get(url) {
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) {
            return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, json: j || {} }; });
        }).catch(function () { return { status: 0, json: {} }; });
}

function fileName(r) {
    var cd = r.headers.get('Content-Disposition') || '';
    var m = /filename="([^"]+)"/.exec(cd);
    return m ? m[1] : 'report.pdf';
}

function status(ref, token) {
    return get('/api/dementia-report/pass?ref=' + encodeURIComponent(ref)
        + '&token=' + encodeURIComponent(token || '') + '&locale=' + encodeURIComponent(locale()));
}

/* ── право и сборка ──────────────────────────────────────────────────── */

/**
 * Завести право ОДИН раз на результат — при намерении, а не на показ. В
 * запросе только локаль: результат уходит на сервер лишь при сборке.
 */
function park() {
    if (!CUR) return Promise.resolve(null);
    var it = findItem(load(), function (x) { return x.rid === CUR.rid; });
    if (it && it.pass) return Promise.resolve({ ref: it.pass.ref, token: it.pass.token });
    if (PARKING) return PARKING;

    /* Ответ, пришедший после нового результата, описывает ПРЕЖНИЙ —
     * присвоить его значило бы продать новый результат по чужому праву. */
    var forRid = CUR.rid;
    var mine = PARKING = post('/api/dementia-report/pass', { locale: locale() }).then(function (r) {
        if (PARKING === mine) PARKING = null;
        var j = r.json || {};
        if (!j.ok) return null;
        setPass(forRid, { ref: j.ref, token: j.token });
        ae('dtr_pass_saved', { ref: j.ref });
        if (!CUR || CUR.rid !== forRid) return null;
        return { ref: j.ref, token: j.token };
    });
    return mine;
}

/** Собрать PDF по праву и результату. */
function render(ref, token, rep) {
    return post('/api/dementia-report/render', {
        ref: ref, token: token || '', rid: rep.rid, payload: rep.payload, locale: locale()
    }, true).then(function (r) {
        if (r.blob) {
            return { ok: true, blob: r.blob, name: r.name };
        }
        var j = r.json || {};
        return { ok: false, error: j.error || ('http_' + r.status), status: r.status };
    });
}

/** Выдать разбор вошедшему по кнопке карточки: право заводится, если его ещё нет. */
function issue() {
    if (!CUR) return Promise.resolve({ ok: false, error: 'no_result' });
    var rep = CUR;
    return park().then(function (p) {
        if (!p) return { ok: false, error: 'park' };
        return render(p.ref, p.token, rep);
    });
}

/**
 * Файл — через общий примитив: <a download> на blob молча не работает в
 * Android WebView (за это отвечает __downloadFile).
 */
function download(blob, name) {
    if (window.__downloadFile) return window.__downloadFile(blob, name);
    try {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = name;
        document.body.appendChild(a);
        a.click();
        setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 4000);
    } catch (e) {}
    return Promise.resolve(true);
}

/**
 * Отдать собранный PDF и дождаться вердикта примитива: «файл скачан» и пометка
 * «получено» — только после него (контракт __downloadFile). Вердикт «нет»
 * (iOS ждёт тапа, жест истёк, пока сервер собирал файл) — showSave(again):
 * кнопка «Скачать» сохраняет тот же файл новым нажатием, без второй сборки.
 */
function hand(res, rid, onSaved, showSave) {
    return Promise.resolve(download(res.blob, res.name))
        .then(function (v) { return v !== false; }, function () { return false; })
        .then(function (ok) {
            if (ok) { if (rid) markGot(rid); onSaved(); return; }
            ae('dtr_save_held', {});
            showSave(function () { hand(res, rid, onSaved, showSave); });
        });
}

/* ── разметка слота на экране результата ─────────────────────────────── */

function gate() { return document.querySelector('[data-perk-gate][data-perk="' + PERK + '"]'); }

function relocate() {
    var g = gate();
    var slot = document.getElementById('dtReportSlot');
    if (g && slot && g.parentNode !== slot) slot.appendChild(g);
}
/** Карточка возвращается «домой» ДО перерисовки панели: иначе умрёт вместе с ней. */
function unmount() {
    var g = gate();
    var home = document.getElementById('dtGateHome');
    if (g && home && g.parentNode !== home) home.appendChild(g);
}

function setStatus(msg, kind) {
    var el = document.getElementById('dtReportStatus');
    if (!el) return;
    el.textContent = msg || '';
    el.className = 'dt-report-status' + (kind ? ' ' + kind : '');
    el.hidden = !msg;
}

/** Строка «разбор оплачен» с кнопкой — нажатие даёт браузеру жест для файла. */
function paidBlock(text, btnLabel, onClick) {
    var box = document.getElementById('dtReportPaid');
    if (!box) return;
    box.innerHTML = '<p class="dt-report-paid-t">' + esc(text) + '</p>'
        + '<button type="button" class="dt-btn dt-btn-primary" id="dtReportPaidBtn">' + esc(btnLabel) + '</button>';
    box.hidden = false;
    var btn = document.getElementById('dtReportPaidBtn');
    if (btn) btn.addEventListener('click', function () { onClick(btn); });
}

/**
 * Карточку покупки прячем СЛОТОМ, а не её собственным `hidden`: perk-gate
 * снимает его при каждой перерисовке (setContext, обновление после выдачи), и
 * карточка вернулась бы поверх «разбор уже оплачен».
 */
function hideCard() {
    var slot = document.getElementById('dtReportSlot');
    if (slot) slot.hidden = true;
}

/** Разбор этого результата получен — дальше только «скачать ещё раз». */
function showGot(ref, token) {
    hideCard();
    setStatus('', '');
    paidBlock(T('report_ready'), T('report_again'), function (btn) { takeWith(ref, token, btn); });
}

function takeWith(ref, token, btn, after) {
    if (!CUR) return;
    var rep = CUR;
    var prev = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = T('report_working') || prev; }
    render(ref, token, rep).then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = prev; }
        if (res.ok) {
            ae('dtr_issued', { via: 'paid_pass' });
            if (after) after();
            hand(res, rep.rid, function () { if (CUR === rep) showGot(ref, token); },
                function (again) { if (CUR === rep) paidBlock(T('report_save'), T('report_download'), again); });
            return;
        }
        ae('dtr_render_fail', { error: res.error });
        setStatus(res.error === 'other_result' ? T('report_other_result') : T('report_failed'), 'warn');
    });
}

/**
 * Что уже оплачено для ЭТОГО результата или ждёт результата: своё право,
 * право из письма (другой браузер) или оплаченное вошедшим где-то ещё.
 */
function checkPaid() {
    if (!CUR) return;
    var rid = CUR.rid;
    var s = load();
    var it = findItem(s, function (x) { return x.rid === rid; });

    if (it && it.pass) {
        status(it.pass.ref, it.pass.token).then(function (r) {
            var j = r.json || {};
            if (!CUR || CUR.rid !== rid || !j.ok || !j.paid) return;
            // Право этого результата уже оплачено — карточка покупки не нужна.
            hideCard();
            paidBlock(T(j.issued ? 'report_ready' : 'report_paid'), T(j.issued ? 'report_again' : 'report_download'),
                function (btn) { takeWith(it.pass.ref, it.pass.token, btn); });
        });
        return;
    }

    if (s.paid && s.paid.ref) {
        var p = s.paid;
        status(p.ref, p.token).then(function (r) {
            var j = r.json || {};
            if (!CUR || CUR.rid !== rid) return;
            if (!j.ok || !j.paid || j.bound) { var s2 = load(); s2.paid = null; save(s2); return; }
            paidBlock(T('report_pending'), T('report_pending_btn'), function (btn) {
                takeWith(p.ref, p.token, btn, function () {
                    setPass(rid, { ref: p.ref, token: p.token });
                    var s3 = load(); s3.paid = null; save(s3);
                });
            });
        });
        return;
    }

    // Вошедший: оплаченное, но не полученное право (заплатил на другом устройстве).
    get('/api/dementia-report/pending').then(function (r) {
        var j = r.json || {};
        if (!CUR || CUR.rid !== rid || !j.ok || !j.refs || !j.refs.length) return;
        var ref = j.refs[0];
        paidBlock(T('report_pending'), T('report_pending_btn'), function (btn) {
            takeWith(ref, '', btn, function () { setPass(rid, { ref: ref, token: '' }); });
        });
    });
}

function register() {
    if (registered || !window.__perkGate) return;
    registered = true;
    window.__perkGate.register(PERK, {
        park: park,
        issue: issue,
        onIssued: function (res) {
            if (res && res.ok && res.blob) {
                ae('dtr_issued', { via: 'card' });
                /* Карточка после выдачи перерисовалась бы «ещё один разбор за
                 * токены» — для ТОГО ЖЕ результата это читалось бы как счёт за
                 * только что полученное. Прячем её и оставляем «ещё раз». */
                var rid = CUR ? CUR.rid : '';
                hand(res, rid, function () {
                    var it = CUR && findItem(load(), function (x) { return x.rid === CUR.rid; });
                    if (it && it.pass) showGot(it.pass.ref, it.pass.token);
                    else setStatus(T('report_ready'), 'ok');
                }, function (again) { hideCard(); paidBlock(T('report_save'), T('report_download'), again); });
            }
        }
    });
}

/**
 * Смонтировать разбор на экране результата. `rep` — {rid, payload}: payload —
 * СТРОКА, ровно та, что уйдёт на сервер (по ней считается отпечаток права).
 */
function mount(rep) {
    if (!enabled() || !rep || !rep.rid || !rep.payload) return;
    CUR = rep;
    PARKING = null;
    remember(rep);
    relocate();
    register();
    var it = findItem(load(), function (x) { return x.rid === rep.rid; });
    try {
        window.__perkGate && window.__perkGate.setContext(PERK,
            it && it.pass && it.pass.token ? { ref: it.pass.ref, token: it.pass.token } : {});
    } catch (e) {}
    checkPaid();
}

/* ── возврат из кассы и письмо ───────────────────────────────────────── */

function notice(msg, kind, btn) {
    var box = document.getElementById('dtPaidNotice');
    if (!box) return;
    box.innerHTML = '<p>' + esc(msg) + '</p>' + (btn ? '<button type="button" class="dt-btn dt-btn-primary" id="dtPaidNoticeBtn">' + esc(btn.label) + '</button>' : '');
    box.className = 'dt-paid-notice' + (kind ? ' ' + kind : '');
    box.hidden = false;
    if (btn) {
        var b = document.getElementById('dtPaidNoticeBtn');
        if (b) b.addEventListener('click', function () { btn.onClick(b); });
    }
    // Только если строка вне экрана — правило сайта: никакой прокрутки к блоку.
    try { box.scrollIntoView({ block: 'nearest' }); } catch (e) {}
}

function renderInto(ref, token, it, btn) {
    var prev = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = T('report_working') || prev; }
    return render(ref, token, it).then(function (res) {
        if (btn) { btn.disabled = false; btn.textContent = prev; }
        return res;
    });
}

function againButton(ref, token, it) {
    return {
        label: T('report_again'),
        onClick: function (b) {
            renderInto(ref, token, it, b).then(function (res) {
                if (res.ok) handNotice(res, ref, token, it);
                else notice(T('report_failed'), 'warn', againButton(ref, token, it));
            });
        }
    };
}

/** Отдать файл из строки сверху страницы (возврат из кассы, письмо, «ждёт»). */
function handNotice(res, ref, token, it) {
    hand(res, it.rid, function () { notice(T('report_ready'), 'ok', againButton(ref, token, it)); },
        function (again) { notice(T('report_save'), 'info', { label: T('report_download'), onClick: again }); });
}

/**
 * `?dt_paid=<право>` (возврат из кассы) или `?dt_paid=…&dt_key=…` (письмо).
 * Работает БЕЗ результата на экране: страница открывается на стартовом экране.
 */
function claimPaid() {
    var q = window.location.search || '';
    var m = /[?&]dt_paid=(\d+)/.exec(q);
    if (!m) { resume(); return; }
    var km = /[?&]dt_key=([A-Za-z0-9-]{8,64})/.exec(q);

    // Адрес чистим сразу: перезагрузка не должна выглядеть как вторая покупка,
    // а ключ права — оставаться в истории браузера.
    try {
        var clean = window.location.pathname
            + q.replace(/([?&])dt_(paid|key)=[^&]*/g, '$1').replace(/[?&]+$/, '').replace(/\?&+/, '?').replace(/&&+/g, '&');
        window.history.replaceState({}, '', clean + window.location.hash);
    } catch (e) {}

    var ref = +m[1];
    var s = load();
    var it = findItem(s, function (x) { return x.pass && +x.pass.ref === ref; });
    var token = it ? it.pass.token : (km ? km[1] : '');
    ae('dtr_paid_return', { ref: ref, has_result: it ? 1 : 0 });

    if (!it) {
        /* Результата в этом браузере нет (другой браузер, очищенная история).
         * Право ждёт следующего результата на этой странице, только если отсюда
         * оно доступно: ключ из письма или вошедший владелец. Гость без ключа
         * (банк вернул в другой браузер) получал «пройдите тест здесь», а после
         * теста — 404 и снова карточку «99 ₽»: ему — дорога через письмо. */
        status(ref, token).then(function (r) {
            var j = r.json || {};
            if (j.ok) {
                var s2 = load();
                s2.paid = { ref: ref, token: token };
                save(s2);
                notice(T('report_no_result'), 'info');
            } else {
                ae('dtr_paid_return_elsewhere', { ref: ref });
                notice(T('report_no_result_mail'), 'info');
            }
        });
        return;
    }

    notice(T('report_claiming'));
    var tries = 0;
    (function attempt() {
        render(ref, token, it).then(function (res) {
            if (res.ok) {
                ae('dtr_issued', { via: 'paid_return' });
                handNotice(res, ref, token, it);
                return;
            }
            // 402 — касса ещё не подтвердила оплату (СБП бывает медленным).
            if (res.status === 402 && tries++ < 20) { setTimeout(attempt, 3000); return; }
            // Обрыв сети — частое дело сразу после возврата из приложения банка.
            if (res.status === 0 && tries++ < 4) { setTimeout(attempt, 2500); return; }
            ae('dtr_render_fail', { error: res.error, where: 'paid_return' });
            if (res.status === 402) { notice(T('report_waiting'), 'info', againButton(ref, token, it)); return; }
            notice(res.error === 'other_result' ? T('report_other_result') : T('report_failed'), 'warn',
                res.error === 'other_result' ? null : againButton(ref, token, it));
        });
    })();
}

/**
 * Обычная загрузка страницы: оплаченное, но ещё не скачанное право из этого
 * браузера (касса перезагрузила страницу, вкладку закрыли на шаге оплаты).
 */
function resume() {
    var s = load();
    var weekAgo = Date.now() - 7 * 864e5;
    var it = findItem(s, function (x) { return x.pass && !x.got && x.at > weekAgo; });
    if (!it) return;
    status(it.pass.ref, it.pass.token).then(function (r) {
        var j = r.json || {};
        if (!j.ok || !j.paid) return;
        ae('dtr_resume_offer', { ref: it.pass.ref });
        notice(T('report_paid_resume'), 'ok', {
            label: T('report_download'),
            onClick: function (b) {
                renderInto(it.pass.ref, it.pass.token, it, b).then(function (res) {
                    if (res.ok) {
                        ae('dtr_issued', { via: 'resume' });
                        handNotice(res, it.pass.ref, it.pass.token, it);
                    } else {
                        notice(T('report_failed'), 'warn', againButton(it.pass.ref, it.pass.token, it));
                    }
                });
            }
        });
    });
}

function boot() { if (enabled()) claimPaid(); }

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}

window.DTReport = { mount: mount, unmount: unmount };
})();
